import { render } from "./App.vue?vue&type=template&id=04021848"
const script = {}

import "./App.vue?vue&type=style&index=0&id=04021848&lang=less"

import exportComponent from "C:\\Users\\rw445\\workspace\\test-typescript\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__